export const diffInDays = (startDate, endDate) => {
  const localStartDate = new Date(startDate);
  const localEndDate = new Date(endDate);
  localStartDate.setHours(0, 0, 0, 0);
  localEndDate.setHours(0, 0, 0, 0);

  return (localEndDate - localStartDate) / (1000 * 60 * 60 * 24);
};
